export const ROUTER_CONFIG = {
  notFound: '404',
  forbidden: '403',
  auth: {
    login: 'login',
  },
};

export const NavigateRouting = {
  authConsoleLogin: '/login'
};
